let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eq0dc")).then(() => parcelRequire('bAAk5'));